import { render, staticRenderFns } from "./SearchHistoryContents.vue?vue&type=template&id=230d8f0a&scoped=true&"
import script from "./SearchHistoryContents.vue?vue&type=script&lang=js&"
export * from "./SearchHistoryContents.vue?vue&type=script&lang=js&"
import style0 from "./SearchHistoryContents.vue?vue&type=style&index=0&id=230d8f0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d8f0a",
  null
  
)

export default component.exports